import * as React from 'react'
import ThemeConsumer from 'ui/multi-product/components/ThemeConsumer'
import classnames from 'classnames'
import { css } from 'emotion'
import { Header } from '..'
import { RequestACall } from '../../RequestACall'

const styles = require('./styles')

interface Props {
  requestACallDisplayed: boolean
  hasOffers: boolean
  loadingCustomizedOffer: boolean
}

export const EmptyState: React.FC<Props> = ({ hasOffers, loadingCustomizedOffer, requestACallDisplayed = false }) =>
  !hasOffers && !loadingCustomizedOffer ? (
    <ThemeConsumer>
      {({ colorTextSecondary }) => (
        <>
          <Header>
            <h2>Unfortunately, we are unable to offer you life insurance at this time.</h2>
          </Header>
          <h3
            className={classnames(
              css`
                color: ${colorTextSecondary};
              `,
              styles.noOffersCopy,
            )}
          >
            We are working on expanding our availability to provide you with the best coverage. Submit your information
            and request a call to get help from one of our agents.
          </h3>
          {!requestACallDisplayed && <RequestACall hideHeader={true} />}
        </>
      )}
    </ThemeConsumer>
  ) : null
